import { https } from "../http";
import store from "../store";
import { setLoadingUserTracking } from "../store/reducers/userTracking";
import { showError } from "../utils";

const getUserTracking = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-today-tracking", data);
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getUserLatestTracking = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-todays-latest-tracking", data);
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const getHighAccuracyLocation = async  (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/get-accurate-location");
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const calculateDistanceMiles = async  (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/calculate-distance", data);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const tracking_clockin = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/clock-in", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    const status = error?.response?.status;
    const message = error?.response?.data?.message;
    // Show user-friendly message for EVV rejections
    if (status === 403 || status === 400) {
      showError(message || "Clock-in rejected", status, false);
    } else {
      showError(message, status);
    }
    throw error;
  }
};

const breakStart = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/break-start", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const breakEnd = async (data, callback) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/break-end", data);
    if (response?.status === 200) {
      callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const tracking_clockout = async (data) => {
  try {
    store.dispatch(setLoadingUserTracking(true));
    let response = await https().post("/userTracking/clock-out", data);
    if (response?.status === 200) {
      // callback?.();
    }
  } catch (error) {
    store.dispatch(setLoadingUserTracking(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const getEvvRecords = async (query) => {
  try {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== "") params.append(key, val);
    });
    const response = await https().get(`/staff/evv-records?${params.toString()}`);
    return response?.data;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return { records: [], total: 0 };
  }
};

export const exportEvvRecords = async (query) => {
  try {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== "") params.append(key, val);
    });
    params.set("perPage", "1000");
    const response = await https().get(`/staff/evv-records?${params.toString()}`);
    return response?.data?.records || [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

export const updateEvvRecord = async (data) => {
  const response = await https().post("/staff/update-evv-record", data);
  return response?.data;
};


const addAttendanceStaff = async (payload) => {
  try {
    let response = await https().post("/userTracking/add-attendance", payload);
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

export { tracking_clockin, getUserTracking, tracking_clockout, getUserLatestTracking, breakStart, breakEnd,addAttendanceStaff };
